import {
  HttpEvent,
  HttpRequest,
  HttpErrorResponse,
  HttpHandlerFn,
  HttpStatusCode,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { PSError } from '@ps/utils';
import { AuthActionsFacade, AuthSelectorsFacade } from '@ps/auth-data-access';
import { APP_ROUTES } from '@ps/core-config';

export function errorInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const router = inject(Router);
  const _authActionsFacade = inject(AuthActionsFacade);
  const _authSelectorsFacade = inject(AuthSelectorsFacade);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        _authSelectorsFacade.isAuthenticated() &&
        error.status === HttpStatusCode.Unauthorized
      ) {
        _authActionsFacade.clearAuth();
      }

      if (
        _authSelectorsFacade.isAuthenticated() &&
        error.status === HttpStatusCode.Forbidden
      ) {
        router.navigate([APP_ROUTES.NOT_FOUND]);
      }

      return throwError(() => PSError.http(error));
    }),
  );
}
